import router from '@/router';
import { Message,Loading } from 'element-ui'

let loading

export default{
	namespace: true,
	state:{
		userinfo2:{},
	
	},
	mutations:{
		// 设置用户数据
		setUserInfo(state,data){
			state.userinfo2 = data
			router.push('/home')
			localStorage.setItem('home_token',state.userinfo2.token)
		},
		// 清除用户信息
		clearUserInfo(state,data){
			
			// for(let i in state){
			// 	state[i] = ""
			// }
			state.userinfo2=''
            

		    localStorage.removeItem('home_token')
			router.push({path:'/home'})
			setTimeout(()=>{
				router.go(0)
			},500)
			
		},
		
	},
	actions:{
		LOGIN({commit,dispatch},data){
			// 登录
			commit('setUserInfo',res.data)
		
		},
		
	}
}